import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "outbound/";

export const getCampaignList = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}campaignlist`, payload, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API campaignList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListAssignment = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getlistassignment`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListAssignment: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDataCampaignColumnTable = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getdatacampaigncolumntable`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDataCampaignColumnTable: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDetailAssignment = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getdetailassignment`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDetailAssignment: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDetailAssignmentTSS = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getdetailassignmenttss`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDetailAssignmentTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredAgents = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}filteredagents`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredAgents: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredStatusCall = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}filteredstatuscall`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredStatusCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListCallSchedule = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getlistcallschedule`,
      { AgentID: agentID },
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API GetListCallSchedule: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListOverdueCallSchedule = async (agentID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getlistoverduecallschedule`,
      { AgentID: agentID },
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListOverdueCallSchedule: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const checkCampaignAutoDial = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}checkcampaignautodial`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API checkCampaignAutoDial: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAssignmentAutoDial = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getassignmentautodial`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAssignmentAutoDial: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const saveAssignmentWithSchedule = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}saveassignmentwithschedule`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API saveAssignmentWithSchedule: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const submitContactVerification = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}submitcontactverification`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API submitContactVerification: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getContactVerification = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getcontactverification`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getContactVerification: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getApplicationDetail = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getapplicationdetail`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getApplicationDetail: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getForm = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getform`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const saveForm = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}saveform`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API saveForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const submitApplication = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}submitapplication`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API submitApplication: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const cancelApplication = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}cancelapplication`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API cancelApplication: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListApplication = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getlistapplication`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListApplication: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const uploadScreenRecording = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}uploadscreenrecording`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API uploadScreenRecording: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
